import socket from './socket'

// "I opened this attachment": lets the chat list, the Files / Photos tabs and the navbar count
// follow each other, in this tab (window event) and in my other tabs / devices (socket event).
const EVENT = 'chat:attachment-opened'

export const announceAttachmentOpened = (messageId) =>
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { id: String(messageId) } }))

// callback(messageId); returns the unsubscribe function
export const subscribeAttachmentOpened = (callback) => {
  const onWindow = (e) => callback(e.detail?.id)
  const onSocket = (data) => callback(data?.messageId)

  window.addEventListener(EVENT, onWindow)
  socket.on('attachmentOpened', onSocket)

  return () => {
    window.removeEventListener(EVENT, onWindow)
    socket.off('attachmentOpened', onSocket)
  }
}
